import defaultItems from '../../../../../common/defaultItems';
import surveyQuickBlockTitle from './common/sharedContents';

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'eNPS Survey',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: '1',
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                ...surveyQuickBlockTitle,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'SURVEY',
                            content: {
                                ...defaultItems.SURVEY.content,
                                type: 'ENPS',
                                iconSize: 24,
                            },
                        },
                    ],
                },
            ],
        },
    };
}
